import { Component, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { LoadProcess, LoaderService } from '../../services'
@Component({
	selector: 'loader',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "./loader.html",
	styles: [require("./loader.scss")]
})
export class Loader {
	private static defaultMinDisplayTimeMs = 0;
	private static defaultMinWatinginTimeMs = 100;

	public processList: LoadProcess[];
	@Input() minDisplayTimeMs;
	@Input() minWaitingTimeMs;

	private timestampOfVisibility: number;
	private lastSettedVisible: boolean;
	private _visible: boolean;



	constructor(loaderService: LoaderService, private changeDetectorRef: ChangeDetectorRef) {
		this.processList = []
		loaderService.processAdded.subscribe(loadProcess => this.addLoadProcess(loadProcess))
		loaderService.processRemoved.subscribe(loadProcess => this.removeLoadProcess(loadProcess))
		setInterval(() => {
			console.log("loaders waiting: ", this.processList)
		}, 60000)
	}

	private addLoadProcess(loadProcess: LoadProcess) {
		this.processList.push(loadProcess)
		this.setVisible(true)
	}

	private removeLoadProcess(loadProcess: LoadProcess) {
		this.processList.splice(this.processList.indexOf(loadProcess), 1)
		if (this.processList.length === 0) {
			this.setVisible(false)
		}
	}

	private getMinWaitingTime= (): number => {
		if (this.minWaitingTimeMs) {
			return this.minWaitingTimeMs
		}
		return Loader.defaultMinWatinginTimeMs
	}

	private getMinDisplayTime = (): number => {
		if (this.minDisplayTimeMs) {
			return this.minDisplayTimeMs
		}
		return Loader.defaultMinDisplayTimeMs
	}

	private calcTimestampForHide= (timestamp: number) => {
		if (!timestamp) {
			return 0;
		}
		let calcTimestampForHide = timestamp + this.getMinDisplayTime();
		return calcTimestampForHide;
	}

	private calcTimetoDisplay = (timestamp: number) => {
		return this.calcTimestampForHide(timestamp) - Date.now();
	}

	private hideLoader() {
		this._visible = false;
		this.timestampOfVisibility = 0;
		this.changeDetectorRef.markForCheck()

	}

	private setVisible(visible: boolean) {
		this.lastSettedVisible = visible;
		if (visible) {
			this.timestampOfVisibility = Date.now();
			setTimeout(() => {
				this._visible = this.lastSettedVisible;
				this.changeDetectorRef.markForCheck()

			}, this.getMinWaitingTime())
		}
		if (!visible) {
			if (this.calcTimestampForHide(this.timestampOfVisibility) < Date.now()) {// Everything is ok just hide
				this.hideLoader();
			} else {
				let displayTime = this.calcTimetoDisplay(this.timestampOfVisibility)
				setTimeout(() => {
					this.hideLoader();
				}, displayTime);
			}
		}
	}

	get visible(): boolean{
		return this._visible;
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/loader/loader.component.ts